// src/design-system/BarChart.tsx
/** أعمدة ذهبية متدرجة فوق خلفية شبكية (مقارنة شهرية أو بين فئات). `labels` اختياري لعرض
 * تسمية تحت كل عمود، و`valueLabels` اختياري لعرض رقم مضيء فوق كل عمود (بدونه الشكل زي ما هو). */
export function BarChart({
  values, labels, valueLabels, height = 80, highlightLast = true,
}: { values: number[]; labels?: string[]; valueLabels?: string[]; height?: number; highlightLast?: boolean }) {
  const max = Math.max(...values, 1);
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-end gap-[7px]" style={{ height }} role="img" aria-label="مقارنة">
        {values.map((v, i) => {
          const last = highlightLast && i === values.length - 1;
          return (
            <div key={i} className="flex flex-1 flex-col items-center justify-end gap-1" style={{ height: "100%" }}>
              {valueLabels && (
                <span className="mono glow-text text-[11px] font-semibold" style={{ color: "#F5E4C0", ["--glow" as string]: "rgba(214,172,85,.5)" }}>
                  {valueLabels[i]}
                </span>
              )}
              <div className="w-full rounded-t-[5px]"
                style={{
                  height: `${Math.max(4, (v / max) * 100)}%`,
                  opacity: last ? 1 : 0.5 + (i / values.length) * 0.4,
                  background: "linear-gradient(180deg,#F0CE8A,rgba(184,138,50,.3))",
                  boxShadow: last ? "0 0 18px rgba(214,172,85,.5)" : "0 0 12px rgba(214,172,85,.25)",
                }} />
            </div>
          );
        })}
      </div>
      {labels && (
        <div className="flex gap-[7px] text-[11px] text-muted-2">
          {labels.map((l, i) => <span key={i} className="flex-1 text-center">{l}</span>)}
        </div>
      )}
    </div>
  );
}
